export const ORDER_CONFIRM_ORDER_DATA = "ORDER_CONFIRM_ORDER_DATA";
export const ORDER_CONFIRM_GET_ORDER_DATA_ASYNC = "ORDER_CONFIRM_GET_ORDER_DATA_ASYNC";
export const ORDER_CONFIRM_SET_ORDER_DATA = "ORDER_CONFIRM_SET_ORDER_DATA";
export const ORDER_CONFIRM_ORDER_DATA_FAIL = "ORDER_CONFIRM_ORDER_DATA_FAIL";
export const ORDER_CONFIRM_PAYMENT_INFO = "ORDER_CONFIRM_PAYMENT_CONFIRM";
export const ORDER_CONFIRM_GET_PAYMENT_INFO_ASYNC = "ORDER_CONFIRM_GET_PAYMENT_INFO_ASYNC";
export const ORDER_CONFIRM_SET_PAYMENT_INFO = "ORDER_CONFIRM_SET_PAYMENT_INFO";
export const ORDER_CONFIRM_PAYMENT_CONFIRM_FAIL = "ORDER_CONFIRM_PAYMENT_CONFIRM_FAIL";